/**
 * Runtime helper to extract readable class names from CSS module hashed class names.
 *
 * Parses className strings that contain CSS module hashes (format: ComponentName-module__className__hash)
 * and extracts both the component name and class name.
 *
 * Examples:
 *   Input: "Button-module__size-slim__RkQLg IconButton-module__iconButton__ZhXN3"
 *   Output: "Button:size-slim IconButton:iconButton"
 *
 *   Input: "open-in-desktop-app-module__container__Xb2Kf"
 *   Output: "open-in-desktop-app:container"
 *
 *   Input: "Button-module__my_size__RkQLg"
 *   Output: "Button:my_size"
 *
 *   Input: "Button-module__size__large__RkQLg"
 *   Output: "Button:size__large"
 *
 *   Input: "Button-module__variant-tertiary__dM-1v"  (hash with dash)
 *   Output: "Button:variant-tertiary"
 */
// eslint-disable-next-line no-underscore-dangle
export function __extractTestId(className: string | undefined | null): string {
	if (!className) return "";

	return className
		.split(" ")
		.map(cls => {
			// CSS module format: ComponentName-module__className__hash
			// Greedy .+ for className captures everything up to the LAST __ delimiter,
			// so the hash (whatever characters it contains) is always discarded
			const match = cls.match(/^(.+)-module__(.+)__.+$/);
			if (match) {
				const componentName = match[1];
				const className = match[2];
				return `${componentName}:${className}`;
			}
			return null;
		})
		.filter((cls): cls is string => cls !== null)
		.join(" ");
}
